import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { forwardRef } from 'react';
import ArrowIosDown from '@crehana/compass.icons.outline/ArrowIosDown';
import { clsx } from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DropdownButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var sizeType = _ref.sizeType,
    size = _ref.size,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    selectedItem = _ref.selectedItem,
    placeholder = _ref.placeholder,
    _ref$buttonProps = _ref.buttonProps,
    buttonProps = _ref$buttonProps === void 0 ? {} : _ref$buttonProps,
    clampSelectedItem = _ref.clampSelectedItem;
  var enabled = !disabled;
  var isSmall = size === 's' || sizeType === 'small';
  var isLarge = size === 'l' || sizeType === 'large';
  var renderContent = function renderContent() {
    if (selectedItem) {
      return /*#__PURE__*/_jsx("p", {
        className: clsx('tw-font-body4 truncate', {
          'tw-text-neutral-light-700 dark:tw-text-neutral-dark-500': !disabled,
          'tw-text-neutral-light-500 dark:tw-text-neutral-dark-600': disabled,
          'tw-truncate tw-text-ellipsis': clampSelectedItem
        }),
        children: selectedItem.labelJsx || selectedItem.label
      });
    }
    if (placeholder) {
      return /*#__PURE__*/_jsx("span", {
        className: clsx({
          'tw-text-neutral-light-700 dark:tw-text-neutral-dark-500': !disabled,
          'tw-text-neutral-light-500 dark:tw-text-neutral-dark-600': disabled
        }),
        children: placeholder
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread({
    type: "button"
  }, buttonProps), {}, {
    ref: ref,
    className: clsx(buttonProps.className, 'tw-relative tw-pl-1.6 tw-pr-3.2 tw-text-left tw-w-full tw-rounded-[1rem] tw-bg-neutral-light-100 dark:tw-bg-neutral-dark-700 tw-border tw-border-solid  dark:tw-text-neutral-light-100  focus:tw-outline-none focus:tw-border-[0.1rem] disabled:tw-bg-neutral-light-400 dark:disabled:tw-bg-neutral-dark-500 disabled:tw-text-neutral-light-500 dark:disabled:tw-text-neutral-dark-600', {
      'focus:tw-border-primary-light-500 dark:focus:tw-border-primary-dark-300 active:tw-border-primary-light-500 dark:active:tw-border-primary-dark-300 disabled:tw-border-none': !error,
      'tw-border-alert-400 dark:tw-border-alert-300': error,
      'tw-border-neutral-light-500 dark:tw-border-neutral-dark-600': !isOpen && !error,
      'hover:tw-border-primary-light-300 dark:hover:tw-border-primary-dark-300': !isOpen,
      'tw-border-primary-light-500 dark:tw-border-primary-dark-300': isOpen && !error,
      'tw-h-5.6 tw-py-1.6': isLarge,
      'tw-h-4 tw-py-0.8': isSmall,
      'tw-cursor-not-allowed': disabled
    }),
    children: [renderContent(), /*#__PURE__*/_jsx("span", {
      className: clsx('tw-absolute tw-top-0 tw-bottom-0 tw-right-0 tw-w-3.6'),
      children: /*#__PURE__*/_jsx("span", {
        className: clsx('tw-absolute tw-right-0.8 tw-transition-transform tw-duration-200 tw-ease-linear', {
          'tw-top-0.8': isSmall,
          'tw-top-1.6': isLarge
        }),
        style: {
          transform: "rotate3d(1, 0, 0, ".concat(isOpen ? '180deg' : '0deg', ")"),
          transformOrigin: 'center center'
        },
        children: /*#__PURE__*/_jsx(ArrowIosDown, {
          className: clsx('block', {
            'tw-text-primary-light-500 dark:tw-text-secondary-dark-500': enabled,
            'tw-text-neutral-light-500 dark:tw-text-neutral-dark-600': disabled
          }),
          size: 20
        })
      })
    })]
  }));
});
DropdownButton.displayName = 'DropdownButton';
export default DropdownButton;